import React, { useImperativeHandle } from "react";
import { useRequest, useUpdateEffect } from "ahooks";
import { useGlobalState } from "@/GlobalProvider";
import { useTranslation } from "@/langs/useTranslation";
import { getScheduleDeployUsers } from "@/apis/apiCollection";
import SingleSelector from "../SingleSelector";

const ScheduleDeployMembers = React.forwardRef(
  ({ disabled, name, value, onChange }, ref) => {
    const { t } = useTranslation();
    const { currentCompanyId } = useGlobalState();
    const { data = [], run } = useRequest(async () => {
      const res = await getScheduleDeployUsers();
      return res.data.map(item => ({ id: item.user_id, name: item.user_name }));
    });

    useUpdateEffect(run, [currentCompanyId]);

    useImperativeHandle(ref, () => ({
      getOptions: () => data.data
    }));

    return (
      <SingleSelector
        placeholder={t({ defaultMessage: "选择部署人" })}
        options={data}
        clearable
        disabled={disabled}
        name={name}
        value={value}
        onChange={onChange}
      />
    );
  }
);

export default ScheduleDeployMembers;
